import template from './attendance-list.html';
import controller from './attendance-list.controller';

let attendanceListComponent = {
  bindings: {},
  template,
  controller
};

export default attendanceListComponent;



// WEBPACK FOOTER //
// ./client/app/components/attendance/attendance-list.component.js